module.exports = __webpack_public_path__ + "static/media/slide-3t.7ec097f7.JPG";